import { ChevronDownIcon} from '@chakra-ui/icons';
import { Button, chakra, Heading, Stack, Text} from '@chakra-ui/react';
import React from 'react';
import useLocalizedNavigate from 'Utils/useLocalizedNavigate';
import { AppRoutes } from 'Routes/AppRoutes';
import { ILoopLandingPageLocalizationDocument } from 'Types/Interface/Sanity';

interface IHomeJumbotronProps{
	loopLandingPageLocalization: ILoopLandingPageLocalizationDocument | null;
}

export const HomeJumbotronSection = ({loopLandingPageLocalization}:IHomeJumbotronProps) => {
	const navigate = useLocalizedNavigate();
	return(
		<Stack 
			py={['70px','100px']} 
			spacing={10} 
			textAlign={['left','center']} 
			justifyContent={'center'} 
			alignItems={['start','center']}
			h={'100vh'}
		>
			<Heading textTransform={'uppercase'} fontSize={{ base: '40px', tablet: '2xl', xxl: '5xl' }} w={'100%'}>
				{loopLandingPageLocalization?.heroTitlePart1} <chakra.span color={'darkCoral'}>
					{loopLandingPageLocalization?.heroTitleHighlight}</chakra.span> 
				<br/> {loopLandingPageLocalization?.heroTitlePart2}
			</Heading>
			<Stack spacing={['20px']}>
				<Text w={['', '700px']} fontSize={['16px','16px']}>
					{loopLandingPageLocalization?.heroSubTitle}
				</Text>
			</Stack>
			
			<Button boxShadow={'0px 20px 40px 0px rgba(18, 27, 38, 0.14)'} variant={'primary'} 
				w={['160px','200px']} h={['50px','60px']} borderRadius={['10px','20px']} onClick={() => navigate(AppRoutes.register)}
			>Get Started</Button>
			<ChevronDownIcon display={['none', 'block']} boxSize={'30px'}/>
		</Stack>
	);
};